import type { GetUserProfile200PreferencesTheme } from './getUserProfile200PreferencesTheme';

export type GetUserProfile200Preferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: GetUserProfile200PreferencesTheme;
};
